import * as Helpers from "@tamagui/helpers";
import { getConfig } from "./config.js";
import {
  getAllRules,
  getAllSelectors,
  getAllTransforms
} from "./helpers/insertStyleRule.js";
import { mediaState } from "./hooks/useMedia.js";
class TamaguiManager {
  constructor() {
    this.Helpers = Helpers;
  }
  get mediaState() {
    return { ...mediaState };
  }
  get config() {
    return getConfig();
  }
  get insertedRules() {
    return getAllRules();
  }
  get allSelectors() {
    return getAllSelectors();
  }
  get allTransforms() {
    return getAllTransforms();
  }
  get identifierToValue() {
    return identifierToValue;
  }
}
const Tamagui = new TamaguiManager();
const identifierToValue = /* @__PURE__ */ new Map();
const getValueFromIdentifier = (identifier) => {
  return identifierToValue.get(identifier);
};
const setIdentifierValue = (identifier, value) => {
  identifierToValue.set(identifier, value);
};
export {
  Tamagui,
  getValueFromIdentifier,
  setIdentifierValue
};
//# sourceMappingURL=Tamagui.js.map
